import DxmlText from "../DxmlText"
import { WebEditorContext, TextLibraryContext, SelectableTextContext } from "../../../../../contexts"
import { useContext, useEffect, useState } from "react"
import { useClassNames } from '../../../../../hooks/useClassNames';
import * as Constants from "../../../../../utils/constants"
import _ from "lodash"
import { useEditorFile } from "../../../../../hooks/useEditorFile";
import DxmlInsertedText from "./DxmlInsertedText";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../../translations/translationsConstants";

export default function DxmlInsertPoint({ editorInsertPoint }) {
    const { editorDisabled, isLoading, editorFileRef, autoSaveEditorFile, setSideBarState, handleActionMenuBar, lastUsedQuillRef, setLastUsedQuillId, quillRef } = useContext(WebEditorContext);
    const { selectedEditorInsertPoint, setSelectedEditorInsertPoint } = useContext(TextLibraryContext);
    const { selectedTextPartIdRef } = useContext(SelectableTextContext);
    const { getKeyById } = useEditorFile();
    const { t: tc } = useTranslation([resources.common]);
    const { t: te } = useTranslation([resources.edit]);

    const { classNames } = useClassNames();
    const [selectedInsertedEditorText, setSelectedInsertedEditorText] = useState();

    const handleInsertedTextDelete = (insertedEditorText) => {
        const index = editorInsertPoint.Items.findIndex(x => x.Id === insertedEditorText.Id);
        if (index >= 0) {
            editorInsertPoint.Items.splice(index, 1);
        }
        setSelectedInsertedEditorText(null);
        autoSaveEditorFile();
    }

    const handleInsertPointClick = () => {
        setSideBarState(Constants.sideBarState.textLibrary);
        setSelectedEditorInsertPoint(editorInsertPoint);
        selectedTextPartIdRef.current = null;
        lastUsedQuillRef.current = null;
        setLastUsedQuillId(null);
        if (quillRef.current) {
            quillRef.current.blur();
        }
        handleActionMenuBar({
            editorFile: editorFileRef.current,
            actionMenuBar: {
                selectableTextState: Constants.normalState,
                textLibraryState: Constants.normalState,
                previewPdfState: Constants.normalState,
                previewHtmlState: Constants.normalState,
                publishState: Constants.normalState,
                discardState: Constants.normalState,
            },
        });
    }

    return (
        <div>
            {
                editorInsertPoint.Items.map((insertedEditorText) => (
                    <div
                        key={getKeyById(insertedEditorText)}
                        className={classNames((insertedEditorText.Id === selectedInsertedEditorText?.Id) ? "tw-border-2 tw-border-indigo-700 tw-rounded" : "", "")}
                    >
                        {!isLoading && !editorDisabled && insertedEditorText.Id === selectedInsertedEditorText?.Id && (
                            <div className="tw-w-full tw-flex tw-flex-row tw-px-2">
                                <div className="tw-flex-1 tw-text-xs tw-text-indigo-700 tw-font-medium" >
                                    {te(translations.edit.insertPoint.insertedText)}
                                </div>
                                <div className="">
                                    <button
                                        type="button"
                                        className="tw-text-xs tw-text-white tw-font-medium tw-bg-indigo-700 tw-rounded tw-px-1"
                                        onClick={() => handleInsertedTextDelete(insertedEditorText)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleInsertedTextDelete(insertedEditorText);
                                            }
                                        }}
                                        disabled={editorFileRef.current.WebEditorSettings.TextLibraryEnabled === false}
                                    >
                                        {tc(translations.common.delete)}
                                    </button>
                                </div>
                                <div className="tw-ml-1">
                                    <button
                                        type="button"
                                        className="tw-text-xs tw-text-white tw-font-medium tw-bg-indigo-700 tw-rounded tw-px-1"
                                        onClick={() => setSelectedInsertedEditorText(null)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                setSelectedInsertedEditorText(null);
                                            }
                                        }}
                                        disabled={editorFileRef.current.WebEditorSettings.TextLibraryEnabled === false}
                                    >
                                        {tc(translations.common.cancel)}
                                    </button>
                                </div>
                            </div>
                        )}
                        <button
                            type="button"
                            className="tw-w-full"
                            title={te(translations.edit.insertPoint.insertedText)}
                            onClick={() => setSelectedInsertedEditorText(insertedEditorText)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && editorFileRef.current.WebEditorSettings.TextLibraryEnabled === true) {
                                    e.preventDefault();
                                    setSelectedInsertedEditorText(insertedEditorText);
                                }
                            }}
                            disabled={editorFileRef.current.WebEditorSettings.TextLibraryEnabled === false}
                        >
                            <DxmlInsertedText editorText={insertedEditorText} writeEnabled={editorInsertPoint.WriteEnabled} />
                        </button>
                    </div>
                ))}
            {
                editorInsertPoint.EditorText && (
                    <button
                        type="button"
                        className={selectedEditorInsertPoint?.Id === editorInsertPoint.Id && !isLoading && !editorDisabled ? "tw-border-2 tw-border-indigo-700 tw-rounded tw-w-full" : "tw-w-full"}
                        onClick={handleInsertPointClick}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                handleInsertPointClick();
                            }
                        }}
                        disabled={isLoading || editorDisabled || editorFileRef.current.WebEditorSettings.TextLibraryEnabled === false}>
                        <DxmlText editorText={editorInsertPoint.EditorText} />
                    </button>
                )
            }
        </div>
    )
}